import React from "react";
import ReactDOM from "react-dom";
import "./styles.css";
import Left from "./components/Left";
import Right from "./components/Right";

ReactDOM.render(
  <div className="container">
    <Left />
    <Right />
  </div>,
  document.getElementById("root")
);
